'use strict';

/**
 * Get query string param by name
 * window.location.search()
 *
 * @param name - String of param name
 * @return {string} value or empty string if not found
 */
module.exports = function(arr, target, prop) {
	var pairs = [];
	var sum = 0;

	arr = JSON.parse(JSON.stringify(arr));

	//Loop through the input array to get the integers and their remainders.
	for (var i = 0; i < arr.length; i++) {
		var integer;
		var remainder;

		if (typeof arr[i] === 'number') {
			integer = Math.floor(arr[i]);
			remainder = arr[i] - integer;
			arr[i] = integer;
		} else if (typeof arr[i] === 'object' && typeof prop === 'string') {
			var number = parseFloat(arr[i][prop]);
			integer = Math.floor(number);
			remainder = number - integer;
			arr[i][prop] = integer;
		} else {
			return null;
		}

		//Add up all the integers. 'sum' should end up lower than target.
		sum += integer;

		//Put all of the integers, remainders, and indexes into an array for sorting.
		pairs.push({
			index: i,
			integer: integer,
			remainder: remainder
		});
	}

	//Sort descending by the remainders.
	var sorted = pairs.sort(function(a, b) {
		return b.remainder - a.remainder;
	});

	//Loop through the largest remainders, and add 1 to their corresponding ints.
	//Basically rounding up on the numbers with the largest integers,
	//and rounding down on the rest to reach the 'target'
	for (i = 0; i < (target - sum); i++) {
		if (typeof arr[i] === 'number') {
			arr[sorted[i].index] = sorted[i].integer + 1;
		} else if (typeof arr[i] === 'object') {
			arr[sorted[i].index][prop] = sorted[i].integer + 1;
		}
	}

	//Returns a copy of the original array with the numbers rounded by largest remainder.
	return arr;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tscom-util/src/roundByLargestRemainder.js
// module id = 237
// module chunks = 0